import { useState } from 'react';
import { Avatar, Divider, Stack, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { BaseUserDto } from 'tdc-web-backend/users/shemas';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../../../components/button/CustomButton';
import CustomInput from '../../../../../components/custom-input/CustomInput';
import BaseInputLabel from '../../../../../components/custom-inputs/BaseInputLabel';
import AvatarEditorModal from '../Members/Member/components/AvatarEditorModal';

export interface UserBasicDetailsProps {
  userData: (BaseUserDto & { avatar: string }) | null;
  disabled?: boolean;
}

const UserBasicDetails = ({ userData, disabled = false }: UserBasicDetailsProps) => {
  const [openBadge, setBadgeOpen] = useState(false);
  const { t } = useTranslation();
  const form = useFormContext();

  return (
    <>
      <Stack
        direction={{ xs: 'column', gr: 'row' }}
        spacing={3}
        justifyContent="cener"
        divider={<Divider orientation="vertical" flexItem />}
      >
        <Stack width={{ xs: '100%', gr: '28%' }} gap={2.5}>
          <Avatar
            src={form.getValues('avatar') === '' ? userData?.avatar : form.getValues('avatar')}
            alt="Company logo"
            sx={{
              height: '120px',
              width: '120px',
              boxShadow: '6px 6px 15px 0px rgba(151, 71, 255, 0.25)',
            }}
          />
          <CustomButton
            variant="secondary"
            sx={{
              height: '3rem',
              width: 'fit-content',
              // maxWidth: '136px',
              marginTop: '20px !important',
              py: 2,
            }}
            onClick={() => setBadgeOpen(true)}
            disabled={disabled}
          >
            {t('settings.changePhoto')}
          </CustomButton>
        </Stack>
        <Stack width={{ xs: '100%', gr: '36%' }} spacing={3}>
          <CustomInput
            input={<CustomInput.Text />}
            placeholder={t('settings.enterYourFirstName')}
            name="firstName"
            label={t('common.firstName')}
            disabled={disabled}
          />
          <CustomInput
            input={<CustomInput.Text />}
            placeholder={t('settings.enterYourLastName')}
            name="lastName"
            label={t('common.lastName')}
            disabled={disabled}
          />
        </Stack>
        <Stack width={{ xs: '100%', gr: '36%' }} spacing={3}>
          <CustomInput
            input={<CustomInput.Text />}
            placeholder={t('settings.enterYourJobTitle')}
            name="jobTitle"
            label={t('common.jobTitle')}
            disabled={disabled}
          />
          <Stack>
            <BaseInputLabel text={t('common.email')} sx={{ fontSize: '0.75rem !important' }} />
            <Typography variant="bodyMedium3">{userData?.email}</Typography>
          </Stack>
        </Stack>
      </Stack>
      {openBadge && userData && (
        <AvatarEditorModal userData={userData} open={openBadge} setOpen={setBadgeOpen} />
      )}
    </>
  );
};

export default UserBasicDetails;
